export default function formLink(email) {
  return `https://docs.google.com/forms/d/e/1FAIpQLSd3gCbG5s2M-sE4eUab9wXBO95v5avm_jKcCPiNr5MwBwxUmQ/viewform?usp=pp_url&entry.749359789=${encodeURIComponent(
    email
  )}`;
}
